/**
 * Remembers where a logged-out user was heading (e.g. "create a friends league"
 * or "predict this match") so Login / the registration flow can send them there
 * once they're authenticated.
 */
const STORAGE_KEY = 'post_auth_redirect';

export interface PostAuthRedirect {
  path: string;
  state?: Record<string, unknown>;
}

export const setPostAuthRedirect = (path: string, state?: Record<string, unknown>) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ path, state }));
  } catch (e) {
    // sessionStorage unavailable - user just lands on the default page
  }
};

export const consumePostAuthRedirect = (): PostAuthRedirect | null => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(STORAGE_KEY);
    const parsed = JSON.parse(raw);
    // Only allow in-app paths
    if (typeof parsed?.path !== 'string' || !parsed.path.startsWith('/') || parsed.path.startsWith('//')) {
      return null;
    }
    return parsed;
  } catch (e) {
    return null;
  }
};
